import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LevelPage from "./App/Containers/LevelPage/LevelPage";
import LevelPageOrginal from "./App/Containers/LevelPage/LevelPageOrginal";
import LevelPageMobile from "./App/Containers/LevelPage/LevelPageMobile";
import LevelPageResponsive from "./App/Containers/LevelPage/LevelPageResponsive";
import Hero from "./App/Containers/Hero/Hero";
import Login from "./App/Containers/Login/Login";
import Register from "./App/Containers/Register/Register";
import HallOfFame from "./App/Containers/Hall-of-Fame/HallOfFame";
import Prizes from "./App/Containers/Prizes/Prizes";
import About from "./App/Containers/About-us/About";
import Cart from "./App/Components/Cart/Cart";
import PreStart from "./App/Containers/Pre-Start/Pre-Start";
import Rules from "./App/Containers/Rules/Rules"; 

import Welcome from "./App/Containers/Welcome";
import Winner from "./App/Containers/Winner";
import PrivacyPolicy from "./App/Containers/Privacy-Policy";
import Editions from "./App/Containers/Editions";
import Completed_Editions from "./App/Containers/Completed-Editions";
import Current_Editions from "./App/Containers/Current-Editions";
import RefundPolicy from "./App/Containers/Refund-Policy";
import TermsConditions from "./App/Containers/Terms-Conditions";
import NotFound from "./App/Containers/Not-Found";
import Profile from "./App/Containers/Profile";
import UnauthorisedLevel from "./App/Containers/Unauthorised-Level";
import InviteFriends from "./App/Containers/Invite-Friends";
import ForgotPassword from "./App/Containers/Login/Forgot-Password";
import ResetPassword from "./App/Containers/Login/Reset-Password"; 
import PendingVerification from "./App/Containers/Pending-Verification";  
import BecomeaSponsor from "./App/Containers/Contact/BecomeSponsor";
import PrivatePuzzled from "./App/Containers/Contact/PrivatePuzzled";
import Checkpoint from "./App/Containers/LevelPage/Checkpoint";

const MainRouter = () => (
  <Switch>
    <Route exact path="/" component={Hero} />
    <Route exact path="/level-page-original" component={LevelPageOrginal} />   
    <Route exact path="/level-page-mobile" component={LevelPageMobile} />
    <Route exact path="/Level-Page-Responsive" component={LevelPageResponsive} />
    <Route exact path="/hero" component={Hero} />
    <Route exact path="/about-us" component={About} /> 
    <Route exact path="/login/:edition_id" component={Login} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/pre-start" component={PreStart} />
    <Route exact path="/rules" component={Rules} />
    <Route exact path="/register" component={Register} />
    <Route exact path="/hall-of-fame/:id" component={HallOfFame} />
    <Route exact path="/hall-of-fame" component={HallOfFame} />
    <Route exact path="/prizes" component={Prizes} />

    <Route exact path="/Cart" component={Cart} />

    <Route exact path="/welcome" component={Welcome} />
    <Route exact path="/winner/:edition_id" component={Winner} />
    <Route exact path="/editions" component={Editions} />
    <Route exact path="/completed-editions" component={Completed_Editions} />
    <Route exact path="/current-editions" component={Current_Editions} />
    <Route exact path="/privacy-policy" component={PrivacyPolicy} />
    <Route exact path="/refund-policy" component={RefundPolicy} />
    <Route exact path="/terms-conditions" component={TermsConditions} />

    <Route exact path="/not-found" component={NotFound} /> 
    <Route exact path="/profile" component={Profile} /> 
    <Route exact path="/unauthorised-level" component={UnauthorisedLevel} /> 
    <Route exact path="/invite-friends" component={InviteFriends} /> 
    <Route exact path="/pending-verification" component={PendingVerification} />
    <Route exact path="/forgot-password" component={ForgotPassword} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/become-sponsor" component={BecomeaSponsor} />
    <Route exact path="/private-puzzled" component={PrivatePuzzled} /> 
    <Route exact path="/edition/" component={LevelPage} />
    <Route exact path="/edition/:edition_id/:level_name" component={LevelPage} />
    <Route exact path="/edition/:edition_id/:level_name/checkpoint" component={Checkpoint} />
    <Route exact path="/edition/:edition_id/:level_name/:asset" component={LevelPage} />
    {/* <Redirect to="/not-found" /> */}
  </Switch>
);

export default MainRouter;
